import { render, staticRenderFns } from "./Lobbies.vue?vue&type=template&id=5a3bdae6&scoped=true&"
import script from "./Lobbies.vue?vue&type=script&lang=js&"
export * from "./Lobbies.vue?vue&type=script&lang=js&"
import style0 from "./Lobbies.vue?vue&type=style&index=0&id=5a3bdae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3bdae6",
  null
  
)

export default component.exports